"use client";

import { useState } from "react";
import Dialog from "@repo/ui/components/ui/dialog";
import { Button } from "@repo/ui/components/ui/button";
import { SignOut, SignIn } from "@repo/next-shared/utils/auth-actions";
import { useRouter, useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { useCurrentLocale } from "@repo/next-shared/hooks/useCurrentLocale";

export default function LoginHandler() {
  const [open, setOpen] = useState(true);
  const router = useRouter();
  const searchParams = useSearchParams();
  const t = useTranslations("Login");
  const register = searchParams.get("register");
  const redirectUri = searchParams.get("redirectUri");
  const customMessageLabel = searchParams.get("custom-message-label");
  const allowClose = searchParams.get("allow-close");
  const locale = useCurrentLocale();

  async function onSignOut() {
    await SignOut({ redirectTo: "/" }).finally(() =>
      setTimeout(() => setOpen(false), 1000),
    );
  }

  async function onSignInOrRegister(isRegister: boolean) {
    await SignIn(
      "keycloak",
      {
        redirectTo: redirectUri
          ? redirectUri.includes("?")
            ? `${redirectUri}&fromLogin=true${isRegister ? "&fromRegister=true" : ""}`
            : `${redirectUri}?fromLogin=true${isRegister ? "&fromRegister=true" : ""}`
          : `/?fromLogin=true${isRegister ? "&fromRegister=true" : ""}`,
      },
      {
        kc_locale: locale,
        ui_locales: locale,
        ...(isRegister && { kc_action: "register" }),
      },
    );
  }

  function onUserClose() {
    if (allowClose) {
      if (customMessageLabel === "text-make-an-offer") {
        router.back();
      } else {
        router.push("/");
      }
    }
  }

  return (
    <>
      <div className="h-96 flex items-center justify-center text-4xl"></div>
      <Dialog
        preventClose={!allowClose}
        contentClassName="pb-5"
        open={open}
        setOpen={(opened) => {
          setOpen(opened);
          if (!opened) {
            onUserClose();
          }
        }}
        header={register ? t("title-register") : t("title")}
      >
        <div className="text-primary-black">
          <p>
            {customMessageLabel
              ? t(customMessageLabel)
              : register
                ? t("text-register")
                : t("text")}
          </p>
          <div className="mt-10 mb-2 flex gap-4 justify-center h-15 overflow-x-visible max-md:flex-col">
            <Button onClick={() => onSignInOrRegister(false)} variant="default">
              {t("login")}
            </Button>
            <Button
              className=""
              variant="outline"
              onClick={() =>
                register ? onSignInOrRegister(true) : onSignOut()
              }
            >
              {register ? t("register") : t("logout")}
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
